import React, { useState, useEffect } from 'react'
import BreadCrumbComp from '../../../components/breadCrumb'
import { Grid } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { callApiAsync, getExternalSurveyByLinkId, submitExternalSurveyAnswers, getCountries } from '../../../services/apiService'
import { format } from 'date-fns'
import { getTodayYMD, getTodayDateTime, getTodayTime } from '../../../utils/dateUtils'
import { formatCustomDateIsoString } from '../../../services/dateService'
// Fechas: mismo patrón que biomedicalEquipmentBase — format(new Date(...), "yyyy-MM-dd") al enviar; formatCustomDateIsoString para mostrar.
import FormRadioButton from '../../../components/formRadioButton'
import FormTextField from '../../../components/textField/formTextField'
import FormSelect from '../../../components/selects/formSelect'
import FormCalendar from '../../../components/calendar/formCalendar'
import LaddaButton from '../../../components/buttons/laddaButton'
import CustomSnackbar from '../../../components/snackbar'
import './styles.css'

const AnswerSurveyInternational = () => {
    const { surveyOrderId } = useParams()
    const [loading, setLoading] = useState(false)
    const [questions, setQuestions] = useState([])
    const [surveyLoaded, setSurveyLoaded] = useState(false)
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState('')
    const [snackbarSeverity, setSnackbarSeverity] = useState('success')
    const [submitted, setSubmitted] = useState(false)
    const [countryOptions, setCountryOptions] = useState([])
    const [orderInfo, setOrderInfo] = useState(null)
    const [orderNumber, setOrderNumber] = useState('')

    const ratingOptions = Array.from({ length: 10 }, (_, i) => ({
        label: String(i + 1),
        value: i + 1
    }))

    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: {
            clientName: '',
            country: null,
            receptionDate: null,
            receptionTime: null,
            p1: null,
            p2: null,
            p3: null,
            p4: null,
            p5: null,
            p6: null,
            p7: null
        }
    })

    useEffect(() => {
        if (surveyOrderId) {
            loadSurvey()
        }
    }, [surveyOrderId])

    useEffect(() => {
        callApiAsync(
            () => getCountries(),
            (resp) => {
                const data = resp?.data ?? resp
                const countries = Array.isArray(data) ? data : []
                setCountryOptions(
                    countries.map((c) => ({
                        name: c.name || String(c),
                        value: c.name || c.id || String(c)
                    }))
                )
            },
            () => { }
        )
    }, [])

    const loadSurvey = async () => {
        setLoading(true)
        await callApiAsync(
            () => getExternalSurveyByLinkId(surveyOrderId),
            (resp) => {
                const data = resp?.data ?? resp
                const questionsData = Array.isArray(data.questions) ? data.questions : []
                setQuestions(questionsData)
                setOrderInfo(data.orderInfo || null)
                setOrderNumber(data.orderNumber || '')
                setSurveyLoaded(true)
                setLoading(false)
            },
            () => {
                setSurveyLoaded(true)
                setLoading(false)
            }
        )
    }

    const onSubmit = async (formData) => {
        setLoading(true)

        const clientName = typeof formData.clientName === 'string' ? formData.clientName.trim() : ''
        const countryVal = formData.country && (typeof formData.country === 'object' ? formData.country.value : formData.country)

        if (!clientName) {
            setSnackbarMessage('Por favor ingrese el nombre del cliente')
            setSnackbarSeverity('error')
            setSnackbarOpen(true)
            setLoading(false)
            return
        }
        if (!countryVal) {
            setSnackbarMessage('Por favor seleccione el país')
            setSnackbarSeverity('error')
            setSnackbarOpen(true)
            setLoading(false)
            return
        }
        if (formData.receptionDate == null) {
            setSnackbarMessage('Por favor seleccione la fecha de recepción')
            setSnackbarSeverity('error')
            setSnackbarOpen(true)
            setLoading(false)
            return
        }

        const receptionDateVal = format(new Date(formData.receptionDate), 'yyyy-MM-dd')
        let receptionTimeVal =
            formData.receptionTime != null && String(formData.receptionTime).trim() !== ''
                ? String(formData.receptionTime).trim().substring(0, 8)
                : null
        if (!receptionTimeVal) receptionTimeVal = getTodayTime()

        const answers = [
            formData.p1, formData.p2, formData.p3,
            formData.p4, formData.p5, formData.p6, formData.p7
        ].slice(0, questions.length)

        if (questions.length > 0 && answers.some((a, i) => questions[i] && (!a || a < 1 || a > 10))) {
            setSnackbarMessage('Por favor, responda todas las preguntas (escala 1-10)')
            setSnackbarSeverity('error')
            setSnackbarOpen(true)
            setLoading(false)
            return
        }

        const dataToSend = {
            clientName,
            country: countryVal,
            receptionDate: receptionDateVal,
            receptionTime: receptionTimeVal,
            creation_date: getTodayYMD(),
            creation_datetime: getTodayDateTime(),
            answers: answers.length ? answers : formData
        }

        await callApiAsync(
            () => submitExternalSurveyAnswers(surveyOrderId, dataToSend),
            () => {
                setSnackbarMessage('Encuesta enviada correctamente')
                setSnackbarSeverity('success')
                setSnackbarOpen(true)
                setLoading(false)
                setSubmitted(true)
            },
            () => {
  
            }
        )
    }

    if (loading && !surveyLoaded) {
        return (
            <div>
                <BreadCrumbComp />
                <div className="searchTitle">
                    <h1>Cargando encuesta...</h1>
                </div>
            </div>
        )
    }

    if (submitted) {
        return (
            <div>
                <div className="searchTitle">
                    <h1>ENCUESTA CLIENTE INTERNACIONAL</h1>
                </div>
                <div className="table-container">
                    <div className="VContainer" style={{
                        maxWidth: '700px',
                        margin: '0 auto'
                    }}>
                        <h2 className="title-bio-details-chard" style={{ marginBottom: '20px', color: '#6C5CE7' }}>
                            Tu opinión ha sido registrada exitosamente.
                        </h2>
                        <p className="detail-label" style={{ marginBottom: '12px', fontSize: '15px', color: '#333', textAlign: 'left' }}>
                            Agradecemos tu colaboración y el tiempo que dedicaste para compartir tu experiencia con el servicio.
                        </p>
                        <p className="detail-label" style={{ marginBottom: '12px', fontSize: '15px', color: '#333', textAlign: 'left' }}>
                            Tus respuestas serán analizadas para fortalecer nuestros procesos y brindar una atención de mayor calidad.
                        </p>
                        <p className="detail-label" style={{ fontSize: '15px', color: '#333', fontWeight: 'bold', textAlign: 'left' }}>
                            Gracias por tu confianza.
                        </p>
                        <div className="VContainer align-center">

                            <img
                                className="img-logo"
                                src={"/images/seranest_pharma logo_xl.png"}
                                alt="icon"
                                style={{}}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
 
            <div className="searchTitle">
                <h1>ENCUESTA CLIENTE INTERNACIONAL</h1>
            </div>

            <div className="table-container">
                <div style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '25px',
                    marginBottom: '25px',
                    backgroundColor: '#fff'
                }}>
                    <h2 className="title-bio-details-chard" style={{ marginBottom: '15px', color: '#333' }}>
                        Bienvenido(a)
                    </h2>
                    <p className="detail-label" style={{ fontSize: '14px', color: '#555', lineHeight: 1.6 }}>
                        Tu opinión es muy importante para nosotros. Queremos conocer tu nivel de satisfacción con el servicio que te brindamos. La encuesta es breve y tus respuestas serán tratadas de manera confidencial. Agradecemos el tiempo que nos dedicas para ayudarnos a mejorar continuamente.
                    </p>
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div style={{
                        border: '2px solid #6C5CE7',
                        borderRadius: '8px',
                        padding: '20px',
                        marginBottom: '25px',
                        backgroundColor: '#f8f9fa'
                    }}>
                        <p className="select-form-label" style={{ marginBottom: '15px', color: '#6C5CE7', fontWeight: 'bold' }}>
                            Por favor completa los siguientes datos
                        </p>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <p className="info-label">Nombre Cliente</p>
                                <FormTextField
                                    name="clientName"
                                    control={control}
                                    margin="0"
                                    error={errors.clientName}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <p className="info-label">País</p>
                                <FormSelect
                                    name="country"
                                    control={control}
                                    options={countryOptions}
                                    margin="0"
                                    formLabel="Seleccionar País"
                                    error={errors.country}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <p className="info-label">Fecha de recepción</p>
                                <FormCalendar
                                    name="receptionDate"
                                    control={control}
                                    formLabel="Seleccionar Fecha"
                                    margin="0"
                                    error={errors.receptionDate}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <p className="info-label">Hora de recepción</p>
                                <FormTextField
                                    name="receptionTime"
                                    control={control}
                                    margin="0"
                                    type="time"
                                    error={errors.receptionTime}
                                />
                            </Grid>
                        </Grid>
                    </div>

                    <div style={{
                        border: '2px solid #6C5CE7',
                        borderRadius: '8px',
                        padding: '15px',
                        marginBottom: '25px',
                        backgroundColor: '#f8f9fa'
                    }}>
                        <p className="detail-label" style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>
                            Por favor califica tu experiencia con nuestro servicio. Seleccionando un número del 1 al 10, donde: <strong>1 significa Muy insatisfecho(a)</strong> y <strong>10 significa Muy satisfecho(a)</strong>
                        </p>
                    </div>

                    {orderInfo && (
                        <div style={{
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            padding: '15px',
                            marginBottom: '25px',
                            backgroundColor: '#fff'
                        }}>
                            <h3 className="select-form-label" style={{
                                color: '#6C5CE7',
                                fontWeight: 'bold',
                                marginBottom: '12px',
                                fontSize: '14px'
                            }}>
                                Resumen de la Orden de Servicio
                            </h3>
                            <Grid container spacing={2}>
                                {orderInfo.origin && (
                                    <Grid item xs={12} sm={6} md={4}>
                                        <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                            <strong>Origen:</strong> {orderInfo.origin}
                                        </p>
                                    </Grid>
                                )}
                                {orderNumber && (
                                    <Grid item xs={12} sm={6} md={4}>
                                        <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                            <strong>Nro de Orden:</strong> {orderNumber}
                                        </p>
                                    </Grid>
                                )}
                                {orderInfo.provider && (
                                    <Grid item xs={12} sm={6} md={4}>
                                        <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                            <strong>Proveedor:</strong> {orderInfo.provider}
                                        </p>
                                    </Grid>
                                )}
                                {orderInfo.transportMode && (
                                    <Grid item xs={12} sm={6} md={4}>
                                        <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                            <strong>Modalidad de Transporte:</strong> {orderInfo.transportMode}
                                        </p>
                                    </Grid>
                                )}
                                {orderInfo.departureDateProvider && (
                                    <Grid item xs={12} sm={6} md={4}>
                                        <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                            <strong>Fecha salida Inst. proveedor:</strong> {formatCustomDateIsoString(String(orderInfo.departureDateProvider))}
                                        </p>
                                    </Grid>
                                )}
                                {orderInfo.arrivalDateCustoms && (
                                    <Grid item xs={12} sm={6} md={4}>
                                        <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                            <strong>Fecha llegada a Aduana:</strong> {formatCustomDateIsoString(String(orderInfo.arrivalDateCustoms))}
                                        </p>
                                    </Grid>
                                )}
                                {orderInfo.arrivalDateClientFacilities && (
                                    <Grid item xs={12} sm={6} md={4}>
                                        <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                            <strong>Fecha llegada instalaciones cliente:</strong> {formatCustomDateIsoString(String(orderInfo.arrivalDateClientFacilities))}
                                        </p>
                                    </Grid>
                                )}
                                {orderInfo.product && (
                                    <Grid item xs={12} sm={6} md={4}>
                                        <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                            <strong>Producto:</strong> {orderInfo.product}
                                        </p>
                                    </Grid>
                                )}
                                {orderInfo.transitTime !== null && orderInfo.transitTime !== undefined && (
                                    <Grid item xs={12} sm={6} md={4}>
                                        <p className="detail-label" style={{ fontSize: '13px', marginBottom: '5px' }}>
                                            <strong>Tiempo en tránsito:</strong> {orderInfo.transitTime} días
                                        </p>
                                    </Grid>
                                )}
                            </Grid>
                        </div>
                    )}

                    <Grid container spacing={3}>
                        {questions.map((question) => (
                            <Grid item xs={12} key={question.questionNumber}>
                                <div className="mb-20" style={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    backgroundColor: '#fff'
                                }}>
                                    <p className="select-form-label" style={{
                                        color: '#6C5CE7',
                                        fontWeight: 'bold',
                                        marginBottom: '10px',
                                        fontSize: '16px'
                                    }}>
                                        Pregunta {question.questionNumber}
                                    </p>
                                    <p className="detail-label" style={{
                                        marginBottom: '15px',
                                        fontSize: '14px',
                                        color: '#333'
                                    }}>
                                        {question.questionText}
                                    </p>
                                    <FormRadioButton
                                        name={`p${question.questionNumber}`}
                                        control={control}
                                        label=""
                                        options={ratingOptions}
                                        error={errors[`p${question.questionNumber}`]}
                                        flexible={true}
                                    />
                                </div>
                            </Grid>
                        ))}
                    </Grid>

                    <div className="HContainer j-center" style={{ marginTop: '30px' }}>
                        <LaddaButton
                            type="submit"
                            variant="contained"
                            backgroundColor="#6C5CE7"
                            height="50px"
                            borderRadius="15px"
                            width="400px"
                            disabled={loading}
                        >
                            <div className="IHContainer align-center">
                                <p className="button_text">Enviar Respuestas</p>
                            </div>
                        </LaddaButton>
                    </div>
                </form>
            </div>

            <CustomSnackbar
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={() => setSnackbarOpen(false)}
            />
        </div>
    )
}

export default AnswerSurveyInternational
